module.exports = __webpack_public_path__ + "img/1970East-012_WEB-min.01c833fd.jpg";